import { Mail, CalendarClock, ChevronRight } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface SupportRowProps {
  href: string;
  icon: React.ReactNode;
  label: string;
  sublabel: string;
}

const BOOK_A_CALL_URL = 'https://calendar.app.google/d9CSeMoTKC3v4Q3W7';

function SupportRow({ href, icon, label, sublabel }: SupportRowProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 border-b border-border p-4 last:border-b-0 hover:bg-muted/60"
    >
      <span className="flex-none text-primary">{icon}</span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-primary">{label}</span>
        <span className="block truncate text-xs text-muted-foreground">{sublabel}</span>
      </span>
      <ChevronRight className="h-4 w-4 flex-none text-muted-foreground" />
    </a>
  );
}

const SupportFooter: React.FC = () => (
  <Card className="overflow-hidden bg-muted/40">
    <SupportRow
      href="mailto:kunal@finrite.co"
      icon={<Mail className="h-5 w-5" />}
      label="Email support"
      sublabel="kunal@finrite.co"
    />
    <SupportRow
      href={BOOK_A_CALL_URL}
      icon={<CalendarClock className="h-5 w-5" />}
      label="Book a call"
      sublabel="Talk to the Finrite team"
    />
  </Card>
);

export default SupportFooter;
